import { render, staticRenderFns } from "./SelfUploadedVideos.vue?vue&type=template&id=3d6cdbc4&scoped=true"
import script from "./SelfUploadedVideos.vue?vue&type=script&lang=js"
export * from "./SelfUploadedVideos.vue?vue&type=script&lang=js"
import style0 from "./SelfUploadedVideos.vue?vue&type=style&index=0&id=3d6cdbc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6cdbc4",
  null
  
)

export default component.exports